export const GET_BLOCKS = 'GET_BLOCKS'      // получить все блоки для указанного клиента. Нужно в админке
export const GET_BLOCK = 'GET_BLOCK'        // Получить блок для указанного клиента и модуля портала
export const TOGGLE_BLOCK = 'TOGGLE_BLOCK'  // Переключить активность блока. Нужно для админки
export const ADD_LINK = 'ADD_LINK'          // Добавить ссылку в блок
export const EDIT_LINK = 'EDIT_LINK'        // Изменить данные о ссылке
export const DEL_LINK = 'DEL_LINK'          // удалить ссылку в блоке